'use client';
import React, { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ClientComponent from '../builder/client_component';
import { ProjectData, deleteProject, getProjects, updateProject } from '@/store/projects';
import { Button, DialogContent, Dialog, DialogTitle, IconButton, DialogActions, Box, Tooltip, Alert,Menu,MenuItem,Stack ,Chip} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import brokenImage from "../../assets/images/broken_image.png";
import router from 'next/router';
import AlertMessage, { AlertMessageProps } from '../util/alert_message';
import { navigateWithHistory } from '@/utils';
import ProjectCreationSuccessModal from '@/pages/[vendor]/roomplanonboarding/ProjectCreationSuccessModal';
import { useDispatch } from 'react-redux';
import { actions } from '@/store/builderSlice';
import BuilderSelect from '@/store/builderStoreSelector';
import { Skeleton } from '@mui/material';
const previewStatusConstants={
  initialized:"Initiated",
  progress:'Processing',
  success:'Completed',
  failed:'Failed'
}
interface ProjectsListComponentInput {
  brand?: string;
}

const ProjectsListComponent: React.FC<ProjectsListComponentInput> = ({ brand }) => {
  console.log('projects-page------------------------------')
  const router = useRouter();
  const dispatch=useDispatch()
  const { projectId } = router.query; 
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [selectedProject, setSelectedProject] = useState<any | null>(null);
  const [projects, setProjects] = useState([] as ProjectData[]);
  const [designProjects, setDesignProjects] = useState([] as ProjectData[]);
  const [projectToDelete, setProjectToDelete] = useState<string | null>(null);
  const brandPathEntry = brand && brand !== "nestingale" ? `/${brand}` : "";
  const [editableProjectId, setEditableProjectId] = useState<string | null>(null);
  const [alertMessageProps, setAlertMessageProps] = useState<AlertMessageProps | null>(null);
  const[previewGenerationStatus, setPreviewGenerationStatus] = useState<string>('');
  const [openGeneratePreviewPopup, setOpenGeneratePreviewPopup] = useState<boolean>(false);
  const previewGenerationList = BuilderSelect.generatePreview().previewGenerationList
  const showGeneratePreviewSettledIndicator=BuilderSelect.generatePreview().showGeneratePreviewSettledIndicator
  const getPageTitle = () => {
    const userInfo = localStorage.getItem('gtn');
    const userInfoObj = userInfo ? JSON.parse(userInfo) : {};
    const firstName = userInfoObj.firstName;
    return firstName ? `${firstName}'s Projects` : 'Your Projects';
  }
  useEffect(() => {
    getProjects().then((projectsResp) => {
      let designProjectList: ProjectData[] = [];
      let builderProjectList: ProjectData[] = [];
      projectsResp?.forEach((project: ProjectData) => {
        if (project.origin === 'DESIGN') {
          designProjectList.push(project);
        } else {
          builderProjectList.push(project);
        }
      });
      // if(projectId){
      //   designProjectList = designProjectList.filter(e => e.projectId == projectId);
      //   builderProjectList = builderProjectList.filter(e => e.projectId == projectId);
      // }
      setSelectedProject(designProjectList[0] || builderProjectList[0]);
      setDesignProjects(designProjectList);
      setProjects([...designProjectList, ...builderProjectList]);
      setLoading(false);
      //check for opening generate preview alert modal
     const isGeneratePreviewInitiated = [...designProjectList, ...builderProjectList].some(
        (project) => {
          const status = project?.previewStatus?.toLowerCase();
          return (
            status === previewStatusConstants.progress.toLowerCase() ||
            status === previewStatusConstants.initialized.toLowerCase()
          );
        }
      );

      if (isGeneratePreviewInitiated&&!showGeneratePreviewSettledIndicator) {
        setOpenGeneratePreviewPopup(true);
      }
    }, (err) => {
      console.log(err);
      setAlertMessageProps({
        type: 'error',
        message: 'Error getting projects, please try again later!'
      });
    });
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // when there is a change in showGeneratePreviewSettledIndicator that means there is a change in  generate previewStatus, so we again run this effect to get fresh data(giving as dependency)
  }, [showGeneratePreviewSettledIndicator]);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767); // Detect mobile screen
  };

  useEffect(()=>{
    if(projectId){
      setIsPopupOpen(true);
    }
  },[projectId]);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (alertMessageProps) {
      timer = setTimeout(() => {
        setAlertMessageProps(null);
      }, 10000); // Close after 10 seconds
    }
    return () => {
      clearTimeout(timer);
    };
  }, [alertMessageProps]);

  const handleEditClick = (e: React.MouseEvent, projectId: string) => {
    e.stopPropagation();
    setEditableProjectId(projectId);
  };
  const handleBlur = () => {
    setEditableProjectId(null);
  };
  const handleKeyDown = (e: React.KeyboardEvent, projectId: string) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setEditableProjectId(null);
      let updatedProjectName = e.currentTarget?.innerHTML?.trim();
      console.log("Updating project name: ", updatedProjectName);
      if (!updatedProjectName) return;
      let previousProjectName = projects.find((project: ProjectData) => project.projectId === projectId)?.projectName || updatedProjectName;
      let updatedProjects = projects.map((project: ProjectData) => {
        if (project.projectId === projectId) {
          project.projectName = updatedProjectName;
        }
        return project;
      }) as ProjectData[];
      setProjects(updatedProjects);
      updateProject(projectId, { projectName: updatedProjectName }).then((updateResp) => {
        console.log(updateResp);
        setAlertMessageProps({
          type: 'success',
          message: 'Project name updated successfully!'
        });
      }, (err) => {
        console.log(err);
        setProjects(projects.map((project: ProjectData) => {
          if (project.projectId === projectId) {
            project.projectName = previousProjectName;
          }
          return project;
        }) as ProjectData[]);

        setAlertMessageProps({
          type: 'error',
          message: 'Error updating project name. Please try again later.'
        });
      }
      );
    }
  };
const onClosePopUp = () =>{
  setIsPopupOpen(false);
}
  const handleDeleteClick = (projectId: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setProjectToDelete(projectId);
  };

  const handleConfirmDelete = () => {
    console.log(`Deleting project with ID: ${projectToDelete}`);
    if (!projectToDelete) return;
    deleteProject(projectToDelete).then((deleteResp) => {
      console.log(deleteResp);
      setProjects(projects.filter((project: ProjectData) => project.projectId !== projectToDelete));
      setAlertMessageProps({
        type: 'success',
        message: 'Project successfully deleted!'
      });
    }, (err) => {
      console.log(err);
      setAlertMessageProps({
        type: 'error',
        message: 'Error deleting project, please try again later!'
      });
    });
    setProjectToDelete(null);
  };

  const handleCancelDelete = () => {
    setProjectToDelete(null);
  };

  function onProjectClick(project: any, e: React.MouseEvent): void {
    e.stopPropagation();
    // navigateWithHistory(router, `${brandPathEntry}/project?projectId=${projectId}`);
    {if (isMobile) {
      setSelectedProject(project);
      setIsPopupOpen(true)
      }
     else{
      navigateWithHistory(router, `${brandPathEntry}/builder?projectId=${project.projectId}`);
     }
    }
  }
  function handleClose() {
    setOpenGeneratePreviewPopup(false)
  }
  const handleBackdropClick = (event: any) => {
    // Prevent the popup from closing when clicking outside
    event.stopPropagation();
  };
  const handleShowPreview = (project: ProjectData) => {
    if (isMobile) {
      setSelectedProject(project);
      setIsPopupOpen(true)
    }
    else {
      router.push(`${brandPathEntry}/builder?projectId=${project.projectId}&isPreview=true`);
    }
  }
  function getPreviewStatus(project: ProjectData) {
    switch (project?.previewStatus) {
      //both initiated and progress will share same ui
      case previewStatusConstants.initialized:
      case previewStatusConstants.progress:
        return <>
          <Typography sx={{ fontSize: '12px', color: '#52575C' }}>Preview is almost ready</Typography>
          <Typography sx={{ fontSize: '12px', color: '#52575C' }}>Estimated time remaining: <Typography component='span' sx={{ fontSize: '10px', fontWeight: 'bold' }}>30m</Typography></Typography>
        </>
      case previewStatusConstants.success:
        return <div onClick={(event: any) => {
          event.stopPropagation()
          handleShowPreview(project)
        }}>
          <Typography sx={{ fontSize: '12px', color: '#52575C' }}>Preview is ready!</Typography>
          <Typography sx={{ fontSize: '12px', color: '#0D908E', fontWeight: 'bold' }}>Click to view</Typography>
        </div>
      case previewStatusConstants.failed:
        return <>
          <Typography sx={{ fontSize: '12px', color: '#BB1030' }}>Generate Preview Failed</Typography>
          <Typography sx={{ fontSize: '12px', color: '#0D908E', fontWeight: 'bold' }}>Retry</Typography>
        </>
      default:
        return null
    }
  }
  const skeletons = isMobile ? [1, 2, 3] : [1, 2, 3, 4, 5, 6];
  return (
    <div style={{paddingTop: '20px'}}>
      {loading ? (
        <div>
          <Grid container spacing={2}>
            {skeletons.map((item) => (
              <Grid item key={`skeleton-${item}`} xs={12} sm={6} md={4} lg={3}>
                <Box
                  component='div'
                  sx={{
                    width: '300px',
                    height: '300px',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    borderRadius: '20px',
                    overflow: 'hidden',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    border: 'solid 1px rgba(0,0,0,0.1)',
                  }}
                >
                  {/* Delete button skeleton in top left */}
                  <Box component='div' sx={{ position: 'absolute', top: '10px', left: '10px', zIndex: 1 }}>
                    <Skeleton variant="circular" width={30} height={30} animation="wave" />
                  </Box>

                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="85%"
                    animation="wave"
                  />
                  <Box
                    component='div'
                    sx={{
                      height: '15%',
                      backgroundColor: 'rgba(0, 0, 0, 0.05)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '0 10px',
                      width: '100%',
                    }}
                  >
                    <Skeleton variant="text" width="70%" height={30} animation="wave" />
                    <Skeleton variant="circular" width={30} height={30} animation="wave" />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </div>
      ) : (
        <div>
          {/*<Typography variant="h2" align="left" style={{ paddingBottom: '20px' }}>
              {`${getPageTitle()}`}
            </Typography> */}
          <Grid container spacing={2}>
            {projects.length === 0 && (
              <Grid item xs={12}>
                <Typography variant="h6" align="center" style={{ display: 'flex', textAlign: 'center', justifyContent: 'center', fontSize: '16px', height: '300px', alignItems: 'center' }}>
                  You currently have no projects.
                </Typography>
              </Grid>
            )}

            {projects.map((project: ProjectData, index: number) => (
              <React.Fragment key={project.projectId}>
                {designProjects.length > 0 && index === 0 &&
                  <Grid item xs={12}>
                    <Typography variant="h2" align="left" style={{ paddingBottom: '10px', paddingTop: '10px' }}>
                      Design Projects({designProjects.length}):
                    </Typography>
                  </Grid>
                }

                {designProjects.length > 0 && index === designProjects.length &&
                  <Grid item xs={12}>
                    <Typography variant="h2" align="left" style={{ paddingBottom: '10px', paddingTop: '10px' }}>
                      Builder Projects({projects.length - designProjects.length}):
                    </Typography>
                  </Grid>
                }
                <Grid item key={project.projectId} xs={12} sm={6} md={4} lg={3}>
                  <Box
                    component="div"
                    sx={{
                      width: '300px',
                      height: '300px',
                      display: 'flex',
                      flexDirection: 'column',
                      position: 'relative',
                      cursor: 'pointer',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      maxWidth: '100%',
                      maxHeight: '100%',
                      border: 'solid 1px rgba(0,0,0,0.8)',
                      '&:hover': {
                        'boxShadow': '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)'
                      }
                    }}
                    onClick={(e:any) => onProjectClick(project, e)}
                  >
                    <IconButton
                      style={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                      }}
                      sx={{
                        backgroundColor: '#E5E5E5', // Initial background color
                        border: 'solid 1px rgba(0,0,0,0.5)',
                        '&:hover': {
                          backgroundColor: '#fff', // Brighter color on hover
                        }
                      }}
                      onClick={(e:any) => {
                        e.stopPropagation(); // Prevents the Link from triggering
                        handleDeleteClick(project.projectId, e);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                    <div style={{
                      flex: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '90%', // Ensure the div takes up the full height of the Paper component
                    }}>
                      <img src={project.projectImage ? project.projectImage :
                        (project.metaData?.designImage ? project.metaData?.designImage :(project?.products[0]?.productImage?project?.products[0]?.productImage: brokenImage.src))} alt={project.projectName} style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover', // Maintain aspect ratio and cover entire area
                        }}
                        onError={(e) => {
                          e.currentTarget.src = brokenImage.src; // Provide the path to your dummy image
                          e.currentTarget.onerror = null; // Prevent infinite loop in case dummy image also fails to load
                        }}
                      />
                      {/* preview status label */}
                      {project.previewStatus && <Box component='div'
                        sx={{
                          position: 'absolute',
                          bottom: '15%',
                          right: 0,
                          left: 0,
                          background: 'rgba(255, 255, 255, 0.8)',
                          color: 'white',
                          padding: '4px 8px',
                          borderRadius: '0', // No border radius for a rectangular shape
                          fontSize: '0.875rem',
                          fontWeight: '500',
                          textAlign: 'center'
                        }}
                      >
                        {getPreviewStatus(project)}

                      </Box>

                      }
                    </div>
                    <div
                      style={{
                        height: '15%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'absolute',
                        width: '100%',
                        bottom: '0'
                      }}
                    >
                      {editableProjectId === project.projectId ? (
                        <div
                          key="editableProjectName"
                          contentEditable
                          suppressContentEditableWarning
                          onBlur={handleBlur}
                          onClick={(e) => e.stopPropagation()}
                          onKeyDown={(e) => handleKeyDown(e, project.projectId)}
                          dangerouslySetInnerHTML={{ __html: project.projectName }}
                          style={{
                            background: '#fff',
                            border: '1px solid #fe6526',
                            width: '80%',
                            padding: '5px 5px',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#333',
                            borderRadius: '8px',
                            outline: 'none',
                            transition: 'border-color 0.2s ease-in-out',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                          }}
                        />
                      ) : (
                        <div style={{ position: 'relative', width: '85%' }}>
                          <Typography variant="h6" style={{ color: 'white', display: 'inline' }}>
                            {project.projectName}
                          </Typography>
                          <Tooltip title={<div style={{ color: "white", fontSize: '12px', fontWeight: '600' }}>Edit Project Name</div>} arrow>
                            <IconButton
                              style={{ position: 'absolute', right: '0', top: '-5px' }}
                              sx={{
                                backgroundColor: '#E5E5E5', // Initial background color
                                border: 'solid 1px rgba(0,0,0,0.5)',
                                '&:hover': {
                                  backgroundColor: '#fff', // Brighter color on hover
                                }
                              }}
                              onClick={(e:any) => handleEditClick(e, project.projectId)}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  </Box>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </div>

      )}

      {isPopupOpen && selectedProject && <ProjectCreationSuccessModal builderImg={selectedProject?.roomModel?.thumbnail} designImage={selectedProject?.metaData?.designImage} createdAt={selectedProject?.created_at} onCloseOverlay={onClosePopUp} />}

      <Dialog open={!!projectToDelete} onClose={handleCancelDelete}>
        <DialogTitle variant="h2">Project Delete Confirmation</DialogTitle>
        <DialogContent>
          <div style={{ width: "400px" }}>
            <Typography variant="h6">
              Do you want to delete your project?
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="error" onClick={handleCancelDelete}>No</Button>
          <Button variant="outlined" color="success" onClick={handleConfirmDelete}>Yes</Button>
        </DialogActions>
      </Dialog>

      {alertMessageProps && (<AlertMessage
        type={alertMessageProps.type}
        message={alertMessageProps.message}
        hideAfterSec={10}
        onClose={() => setAlertMessageProps(null)} />)}
           {/* generate preview alert modal */}
      <Menu
        id="account-menu"
        open={openGeneratePreviewPopup}

        onClose={(event, reason) => {
          if (reason === "backdropClick") return; // Prevent closing on outside click
          handleClose();
        }}
        onClick={handleBackdropClick}
        anchorReference="anchorPosition"
        anchorPosition={{ top: window.innerHeight / 2, left: window.innerWidth / 2 }}
        disableAutoFocusItem
        disableEnforceFocus
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              width: '441px',
              background: 'rgba(255, 255, 255, 0.95)',
              borderRadius: '20px',
              mt: 3,
              transform: 'translate(-50%, -50%)',
              position: 'absolute',
              top: '50%',
              left: '50%',
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'center', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'center', vertical: 'center' }}
      >

        <MenuItem sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', whiteSpace: 'normal' }}>
          <Typography sx={{ fontSize: '24px', fontWeight: '600', color: '#52575C' }}>Generating Preview...</Typography>
          <Typography sx={{ fontSize: '16px' }}>Your room preview is being generated,</Typography>
          <Typography sx={{ fontSize: '16px' }}>estimated time remaining: <Typography component="span" sx={{ fontSize: '12px', fontWeight: 'bold' }}>30 minutes</Typography></Typography>
          <Stack spacing={2} direction="row" sx={{ margin: '20px 0' }}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              sx={{ margin: '0 10px', textTransform: 'capitalize' }}
              onClick={handleClose}
            >
              Got it
            </Button>
          </Stack>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ClientComponent(ProjectsListComponent);